// TOP LEVEL IMPORTS
import React from 'react';

const ClientNameRow = ({ client }) => {
  return (
    <div style={s.container}>
      <p style={s.text}>
        Creating a New Contract for{' '}
        <strong>
          {client.firstName} {client.lastName}
        </strong>
      </p>
    </div>
  );
};

const s = {
  text: {
    textAlign: 'center',
    margin: 0,
  },
  container: {
    backgroundColor: '#fff',
    padding: '10px 10px 6px',
    width: '100%',
    borderBottom: '2px solid #efefef',
  },
};

export default ClientNameRow;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/ClientNameRow/index.js